import { gql } from '@apollo/client'
import { pick } from 'ramda'
import { useCleanFilterForRequest } from '@btime/react-contexts'
import React from 'react'

import { analyticsClient } from '../../../../../../utils/apollo/api'
import { useGenericState } from '../../../../../../packages/kiti/components/helpers/GenericState'
import { useQuery } from '../../../../../../utils/apollo/_helpers/useQuery'
import { useSelectedPerspective } from '../../../_shared/PerspectiveDropdown'
import StatePresenter from '../../../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const usePeriodicFormRepliesState = () => React.useContext(Context)
export const usePeriodicFormReplies = () => usePeriodicFormRepliesState()?.periodicFormReplies

const QUERY = gql`
  query PeriodicFormReplies($filter: PeriodicFormRepliesFilter) {
    periodicFormReplies(filter: $filter) {
      totalCount
      date
    }
  }
`

const PeriodicFormRepliesLoader = ({ children }) => {
  const filter = useCleanFilterForRequest() || {}
  const { value } = useGenericState()
  const perspective = useSelectedPerspective()

  const { data, ...state } = useQuery(QUERY, {
    variables: {
      filter: {
        perspective: perspective?.id, //
        ...pick(['placeIds', 'placeLevelIds', 'checklistIds', 'date'], filter)
      }
    },
    client: analyticsClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default PeriodicFormRepliesLoader
